module.exports = {
    expressPort: 8000,
    // siteUrl: (window.location.hostname == "admin.theelderlywellness.com") ? 'https://elderly-admin-service.theelderlywellness.com/api' : 'https://elderly-admin-service.codiflysoftware.com/api'
    siteUrl: 'https://adminservice.mothrly.com/api',
    // siteUrl: 'http://localhost:5022/api',
    // walletService: (window.location.hostname == "admin.theelderlywellness.com") ? 'https://elderly-wallet-service.theelderlywellness.com/api' : 'https://elderly-wallet-service-staging.theelderlywellness.com/api',
    maternityServiceUrl: 'https://maternity-service.mothrly.com/api',
    // maternityServiceUrl: 'http://localhost:3006/api',
    // siteUrl: 'http://localhost:8000/api'
};  
